import { jsx, jsxs } from "react/jsx-runtime";
import { siteNames } from "@seek/melways-sites";
import { Text, TextLink, Box, IconCritical } from "braid-design-system";
import { EMPLOYER_HELP_CENTRE_URL } from "@seek/shared-constants";
import { useTranslations } from "@vocab/react";
import { useEmployerHeaderContext } from "../../../EmployerFooter/EmployerFooter.mjs";
import { translations } from "../../../../EmployerHeader/components/CreditHoldAlert/.vocab/index.mjs";
import { UNIFIED_FINANCE_PHONE_NUMBER } from "@seek/adv-constants";
import { headerZindexMobile, creditHoldAlert } from "../../EmployerHeader.css.mjs";
const AlertHelpCentre = () => {
  const { t } = useTranslations(translations);
  const { urlResolver, site } = useEmployerHeaderContext();
  const href = urlResolver({ path: EMPLOYER_HELP_CENTRE_URL[site] });
  return /* @__PURE__ */ jsx(Text, { size: "small", tone: "critical", children: t(
    "Account is currently on hold due to non-payment link... visit the Help Centre",
    {
      TextLink: (children) => /* @__PURE__ */ jsx(TextLink, { href, children })
    }
  ) });
};
const AlertPhoneNumber = () => {
  const { t } = useTranslations(translations);
  const { site } = useEmployerHeaderContext();
  const financePhoneNumber = UNIFIED_FINANCE_PHONE_NUMBER[site];
  if (!financePhoneNumber) {
    return null;
  }
  return /* @__PURE__ */ jsx(Text, { size: "small", tone: "critical", children: t(
    "Account is currently on hold due to non-payment... For other queries, call...",
    {
      financePhoneNumber,
      Box: (children) => /* @__PURE__ */ jsx(Box, { display: ["block", "inline"], children })
    }
  ) });
};
const CreditHoldAlert = ({ site }) => {
  const showFinancePhoneNumber = site === siteNames.employer.seek.au || site === siteNames.employer.seek.nz;
  return /* @__PURE__ */ jsx(
    Box,
    {
      id: "credit-hold-alert",
      paddingX: "gutter",
      background: "surface",
      className: [headerZindexMobile, creditHoldAlert],
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingY: "small",
          children: [
            /* @__PURE__ */ jsx(Box, { marginRight: "xsmall", children: /* @__PURE__ */ jsx(IconCritical, { tone: "critical", size: "small" }) }),
            showFinancePhoneNumber ? /* @__PURE__ */ jsx(AlertPhoneNumber, {}) : /* @__PURE__ */ jsx(AlertHelpCentre, {})
          ]
        }
      )
    }
  );
};
export {
  CreditHoldAlert
};
